import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/button';
import CustomModal from '../../../components/CustomModal';
import Input from '../../../components/input';
import Select from '../../../components/Select';
import { createPartModelAsync, fetchPartModels, getPartModelsOverview } from '../../../store/Slices/PartModelSlice';
import { partModelValidationSchema } from '../../../utils/Schema';
import { partModelStatusOptions } from '../../../utils/Dropdowns';
import { errorNotify, successNotify } from '../../../utils/toast';

const CreatePartModelModal = ({ show, onHide, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { createPartModelLoading } = useSelector((state) => state.partModels);

    const initialValues = {
        name: '',
        status: 'active'
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            await dispatch(createPartModelAsync(values)).unwrap();
            successNotify('Part model created successfully');
            resetForm();
            onHide();
            
            // Refresh table and overview
            dispatch(fetchPartModels({
                page: currentPage,
                limit: limit,
                body: {}
            }));
            dispatch(getPartModelsOverview());
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <CustomModal heading="Add Part Model" size="lg" show={show} handleClose={onHide}>
            <Formik
                initialValues={initialValues}
                validationSchema={partModelValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="add_user_modal">
                            <h5>Part Model Information</h5>
                            <div>
                                <Input
                                    label="Name"
                                    placeholder="Enter part model name"
                                    type="text"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                    touched={touched.name}
                                />
                            </div>

                            <div>
                                <Select
                                    label="Status"
                                    placeholder="Select status"
                                    options={partModelStatusOptions}
                                    name="status"
                                    value={partModelStatusOptions.find(opt => opt.value === values.status)}
                                    onChange={(option) => setFieldValue('status', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.status}
                                    touched={touched.status}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2" style={{ marginTop: "40px" }}>
                                <Button
                                    submitBtn={() => {}}
                                    loading={createPartModelLoading || isSubmitting}
                                    disabled={createPartModelLoading || isSubmitting}
                                    submitText="Save"
                                    type="submit"
                                    shouldRow={false}
                                    isShowSubmitBtn={true}
                                    isShowCancel={false}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </CustomModal>
    );
};

export default CreatePartModelModal;
